import { getPopupDetails } from '@Actions/popup.actions';
import {
	popupInspectionsLoadingSelector,
	popupSelectedAssetSelector,
} from '@Selectors/popup.selectors';
import { useGlobalization } from '@Translations/useGlobalization';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LabelWithLoading } from './LabelWithLoading';
import { PopupDetailsWrapper } from './PopupDetails.styles';
import { ExtendedDetails } from './ExtendedDetails';
import { useDateFormatter } from './useDateFormatter';
import { Feature } from './types';

interface PopupDetailsProps {
	feature?: Feature;
}

const hasExtendedDetails = (assetType: string | undefined) =>
	assetType === 'wwPipe' || assetType === 'wwManhole';

export const PopupDetails: React.VFC<PopupDetailsProps> = ({ feature }) => {
	const dispatch = useDispatch();
	const { t } = useGlobalization();
	const popupDetails = useSelector(popupSelectedAssetSelector);
	const isLoading = !popupDetails;
	const areInspectionsLoading =
		useSelector(popupInspectionsLoadingSelector) ?? false;
	const formatDate = useDateFormatter();

	useEffect(() => {
		if (!feature) return;
		const [assetType, assetId] = feature.id.split('#');
		dispatch(
			getPopupDetails({
				assetId,
				assetType,
			}),
		);
	}, [feature]);

	return (
		<PopupDetailsWrapper>
			<LabelWithLoading
				label={t('Asset Id')}
				value={popupDetails?.assetId}
				loading={isLoading}
			/>
			<LabelWithLoading
				label={t('Asset Type')}
				value={popupDetails?.assetType}
				loading={isLoading}
			/>
			<LabelWithLoading
				label={t('Install Date')}
				value={formatDate(
					popupDetails?.yearLaid ||
						popupDetails?.yearInstalled ||
						popupDetails?.dateInstalled,
				)}
				loading={isLoading}
			/>
			{hasExtendedDetails(popupDetails?.assetType) && (
				<ExtendedDetails
					popupDetails={popupDetails}
					isLoading={isLoading}
					areInspectionsLoading={areInspectionsLoading}
				/>
			)}
		</PopupDetailsWrapper>
	);
};
